module.exports = __webpack_public_path__ + "resources/img/img_seculetter_email_cloud_security.45668b160d40b2dead38ea1881e38e5d.png";